// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__jVhQE","socialIcons":"footer_socialIcons__4+6zr","iconWrapper":"footer_iconWrapper__1FotO"};